import React, { useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop, CircularProgress } from '@material-ui/core';

import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRatingTemplates } from './redux/actions/ratingTemplatesActions';
import { fetchAllThemes } from './redux/actions/themeActions';
import { AppThemeProvider } from './theme/ThemeProvider';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff',
  },
}));
const App = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const loading = useSelector((state) => state.loadingReducer.loading);

  useEffect(() => {
    dispatch(fetchAllThemes());
    dispatch(fetchRatingTemplates());
  }, []);

  return (
    <AppThemeProvider>
      <LoginPage>
        <HomePage />
      </LoginPage>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </AppThemeProvider>
  );
};

export default App;
